var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 28.8889V27.7778C12.2222 23.4822 15.7044 20 19.9999 20C24.2955 20 27.7777 23.4822 27.7777 27.7778V28.8889",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 28.8889V27.7778C12.2222 23.4822 15.7044 20 19.9999 20C24.2955 20 27.7777 23.4822 27.7777 27.7778V28.8889",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C22.4545 20 24.4444 18.0101 24.4444 15.5556C24.4444 13.101 22.4545 11.1111 20 11.1111C17.5454 11.1111 15.5555 13.101 15.5555 15.5556C15.5555 18.0101 17.5454 20 20 20Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C22.4545 20 24.4444 18.0101 24.4444 15.5556C24.4444 13.101 22.4545 11.1111 20 11.1111C17.5454 11.1111 15.5555 13.101 15.5555 15.5556C15.5555 18.0101 17.5454 20 20 20Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepsIcon);
export default __webpack_public_path__ + "static/media/reps-icon.529e73d5accd414eea1360f67353f919.svg";
export { ForwardRef as ReactComponent };